import type { LandingPlan, LandingPubId } from "./constants";

// Landing-prefixed names: the shared GTM container would log portal names as "pdf portal".
type LandingEvent =
  | "landing_cta_click"
  | "landing_feature_select"
  | "landing_pub_select"
  | "landing_reader_menu_open"
  | "landing_reader_menu_click"
  | "landing_benefits_toggle";

function push(event: LandingEvent, details: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  const w = window as unknown as Window & {
    dataLayer?: Record<string, unknown>[];
  };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event, event_details: details });
}

export type LandingCta =
  "get_epaper" | "subscribe" | "buy_one_issue" | "subscribe_tablet";

// GA4 auto-tracks the outbound click but not which CTA, publication or plan drove it.
export function trackCtaClick(args: {
  ctaName: LandingCta;
  pubId?: LandingPubId;
  plan?: LandingPlan | "tablet";
  price?: string;
}) {
  push("landing_cta_click", args);
}

// In-page state changes GA4 cannot see.
export function trackFeatureSelect(args: {
  feature: "read" | "layout" | "zoom" | "share";
}) {
  push("landing_feature_select", args);
}

export function trackPubSelect(args: {
  pubId: LandingPubId;
  section: "carousel" | "plans";
}) {
  push("landing_pub_select", args);
}

export function trackBenefitsToggle(args: {
  pubId: LandingPubId;
  plan: LandingPlan | "tablet";
  expanded: boolean;
}) {
  push("landing_benefits_toggle", args);
}

export function trackReaderMenuOpen() {
  push("landing_reader_menu_open");
}

export function trackReaderMenuClick(args: { pubId: LandingPubId }) {
  push("landing_reader_menu_click", args);
}
